import apiClient from '../../clienteFebosAPI';

const RESOURCE = '/aduanas/comprobantes';

export const receiptsListSearch = (
  {
    page, items, filters, order, format, query
  }
) => {
  const params = apiClient.queryParams(
    {
      filtros: filters,
      pagina: page,
      itemsPorPagina: items,
      orden: order,
      formato: format,
      query
    }
  );
  return apiClient.get(`/v2/buscar/aduana_comprobante?${params}`, {
    operacionId: 'aduanas.receipts.search'
  });
};

export const receiptsList = (payload) => {
  let params = null;
  if (payload) {
    params = apiClient.queryParams(payload.params);
  }
  return apiClient.get(`${RESOURCE}?${params}`, {
    operacionId: 'aduanas.receipts.list'
  });
};

export const createReceipt = async (payload) => apiClient
  .post(`${RESOURCE}?`, payload, {
    operacionId: 'aduanas.receipts.create'
  });

export const getReceipt = (payload) => {
  let params = null;
  if (payload) {
    params = apiClient.queryParams(payload.params);
  }
  return apiClient.get(`${RESOURCE}/${payload.receiptId}?${params}`, {
    operacionId: 'aduanas.receipt.get'
  });
};

export const invoiceReceipt = async ({ receiptId, issueDate, preview }) => {
  const params = apiClient.queryParams({ simular: preview });
  return apiClient.post(`${RESOURCE}/${receiptId}/facturar?${params}`, { fechaEmision: issueDate },
    { operacionId: 'aduanas.receipts.invoice' });
};

export const cancelReceipt = ({ comprobanteId, message }) => apiClient.post(`${RESOURCE}/${comprobanteId}/anular`,
  { mensaje: message },
  { operacionId: 'aduanas.receipt.cancel' });
